<p>
  offer-manager works!
</p>
